<template>
  <header class="header-default _ui-grid">
    <h1 class="title text-3xl" v-html="data.title" />
    <StructuredText
      v-if="!isEmptyDocument(props.data.text)"
      class="text text-md"
      :data="data.text"
    />
    <Glow />
  </header>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import { isEmptyDocument } from 'datocms-structured-text-utils';
import type { HeaderDefaultFragment } from '#gql';
import Glow from '@/components/site-header/Glow.vue';

const props = defineProps<{
  data: HeaderDefaultFragment;
}>();
</script>

<style scoped lang="scss">
.header-default {
  position: relative;
  width: 100%;
  overflow: visible;

  @media (--vl) {
    padding-block: 12.5rem 0;
  }

  > .title {
    grid-column: 2 / -3;
    hyphens: auto;
  }
  > .text {
    grid-column: 3 / -3;

    padding-top: 2.5rem;
    padding-bottom: 3.25rem;
    text-align: left;
    margin: 0 auto 0 0;
  }

  @media (--vs) {
    & {
      padding: 6.8125rem var(--base-component-padding-inline) 1.5rem
        var(--base-component-padding-inline);
    }
  }
}
</style>
